import ScrollReveal from './scrollreveal.js'

let doc = document;

doc.addEventListener("DOMContentLoaded", function (event) {
    ScrollReveal().reveal("[data-animation-ref]", {
        origin: "bottom",
        distance: "25px",
        duration: 1e3,
        delay: 180,
        scale: 1,
        opacity: 0,
        easing: "ease-out",
        viewOffset: {
            bottom: 200
        }
    });
    let animateCalculate = false;
    let calculate = document.querySelectorAll('.calculate');
    window.addEventListener("scroll", function () {
        let scroll = this.scrollY;
        if (calculate.length > 0) {
            if (scroll >= calculate[0].offsetTop - window.innerHeight + 300 && !animateCalculate) {
                animateCalculate = true;
                for (let i = 0; i < calculate.length; i++) {
                    let symbolAfter = calculate[i].getAttribute('data-symbol-after') || '';
                    let symbolBefore = calculate[i].getAttribute('data-symbol-before') || '';
                    let from = calculate[i].getAttribute('data-from');
                    let to = calculate[i].getAttribute('data-to');
                    let type = calculate[i].getAttribute('data-type');

                    calculate[i].innerHTML = symbolBefore + from + symbolAfter;
                    if (type !== 'time') {
                        for (let k = from; k <= to; k++) {
                            setTimeout(() => {
                                calculate[i].innerHTML = symbolBefore + k + symbolAfter;
                            }, (k / to) * 800)
                        }
                    } else {
                        for (let k = from; k <= to; k++) {
                            setTimeout(() => {
                                let sec_num = parseInt(k, 10);
                                let hours = Math.floor(sec_num / 3600);
                                let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                                let seconds = sec_num - (hours * 3600) - (minutes * 60);
                                if (hours < 10) {
                                    hours = "0" + hours;
                                }
                                if (minutes < 10) {
                                    minutes = "0" + minutes;
                                }
                                if (seconds < 10) {
                                    seconds = "0" + seconds;
                                }
                                calculate[i].innerHTML = hours + ':' + minutes + ':' + seconds;
                            }, (k / to) * 800)
                        }
                    }
                }
            }
        }
    });

});
